import { Root } from "./providers";
import React from "react";

export const root = () => [
    {
        target: "$REACT_ROOT_WRAPPER",
        handler: {
            component: ({ children }: any) => {
                return <Root>{children}</Root>;
            }
        }
    }
];
